import { JobCategory } from 'jobs/types';
import { makeAutoObservable, makeObservable, observable } from 'mobx';
export class DesiredPositionStore {
    valid: boolean = false;
    categories: JobCategory[] = [];
    constructor() {
        makeObservable(this, {
            valid: observable,
        });
    }

    update({ categories }: { categories: JobCategory[] }): void {
        this.categories = categories;
    }
}
